export const sampleData = [
  { month: 'Jul', revenue: 38000, expenses: 28000 },
  { month: 'Aug', revenue: 42000, expenses: 31000 },
  { month: 'Sep', revenue: 39000, expenses: 29000 },
  { month: 'Oct', revenue: 44000, expenses: 32000 },
  { month: 'Nov', revenue: 41000, expenses: 30000 },
  { month: 'Dec', revenue: 45230, expenses: 33500 }
];

// Mock data for the app
export const mockData = {
  accountOptions: [
    { id: "1", name: "Meals & Entertainment" },
    { id: "2", name: "Office Supplies" },
    { id: "3", name: "Equipment" },
    { id: "4", name: "Travel" },
    { id: "5", name: "Chase Card" },
    { id: "6", name: "Checking" },
    { id: "7", name: "Ask My Accountant" },
    { id: "8", name: "Owner Draw" },
    { id: "9", name: "Consulting Revenue" },
    { id: "10", name: "Accounts Receivable" },
    { id: "11", name: "Accounts Payable" }
  ],
  vendorOptions: [
    { id: "1", name: "Starbucks Coffee" },
    { id: "2", name: "Office Depot" },
    { id: "3", name: "Client Payment - ABC Corp" },
    { id: "4", name: "Amazon Business" },
    { id: "5", name: "Walmart Business" },
    { id: "6", name: "Uber" },
    { id: "7", name: "Microsoft" },
    { id: "8", name: "Google Workspace" },
    { id: "9", name: "FedEx" },
    { id: "10", name: "Home Depot" }
  ],
  transactions: [
    { "id": "1", "date": "2025-06-08", "vendor": "30", "description": "Coffee purchase", "amount": -15.67, "account": "94", "suggestedAccount": "Meals & Entertainment", "hasReceipt": false, "messageCount": 2, "unreadMessages": 1, "status": "needs-review", "flags": ["vendor-inconsistency"], "lineItems": [ { "id": "1a", "name": "Coffee", "description": "Coffee", "amount": -12.50, "account": "1" }, { "id": "1b", "name": "Tip", "description": "Tip", "amount": -3.17, "account": "1" } ], "type": "purchase", "deep_link": "https://app.qbo.intuit.com/app/transaction?txnId=1", "messages": [ { "id": 1, "sender": "bookkeeper", "message": "Can you provide the receipt for this Starbucks Coffee transaction?", "timestamp": "2025-06-08 10:30 AM", "isInternal": false }, { "id": 2, "sender": "client", "message": "This was a client meeting. I'll upload the receipt shortly.", "timestamp": "2025-06-08 2:15 PM", "isInternal": false } ], "resolved": false, "class": "5000000000000279366" },
    { "id": "2", "date": "2025-06-07", "vendor": "56", "description": "Office supplies", "amount": -234.89, "account": "11", "suggestedAccount": "Office Supplies", "hasReceipt": true, "messageCount": 0, "unreadMessages": 0, "status": "uncategorized", "flags": ["uncategorized"], "lineItems": [ { "id": "2a", "name": "Paper & Supplies", "description": "Paper & Supplies", "amount": -189.99, "account": "2" }, { "id": "2b", "name": "Printer Ink", "description": "Printer Ink", "amount": -44.90, "account": "2" } ], "type": "bill", "deep_link": "https://app.qbo.intuit.com/app/transaction?txnId=2", "messages": [ { "id": 1, "sender": "bookkeeper", "message": "Can you provide the receipt for this Office Depot transaction?", "timestamp": "2025-06-07 9:00 AM", "isInternal": false } ], "resolved": false, "class": "5000000000000279366" },
    { "id": "3", "date": "2025-06-06", "vendor": "40", "description": "Invoice payment", "amount": 2500.00, "account": "6", "suggestedAccount": "Accounts Receivable", "hasReceipt": false, "messageCount": 1, "unreadMessages": 0, "status": "flagged", "flags": ["unapplied-ar"], "lineItems": [ { "id": "3a", "name": "Invoice #INV-001", "description": "Invoice #INV-001", "amount": 2500.00, "account": "9" } ], "type": "invoice", "deep_link": "https://app.qbo.intuit.com/app/transaction?txnId=3", "messages": [ { "id": 1, "sender": "bookkeeper", "message": "Please confirm this payment from ABC Corp is for invoice #INV-001.", "timestamp": "2025-06-06 11:00 AM", "isInternal": false } ], "resolved": false, "class": "3" },
    { "id": "4", "date": "2025-06-05", "vendor": "46", "description": "Office equipment", "amount": -189.99, "account": "5", "suggestedAccount": "Equipment", "hasReceipt": true, "messageCount": 0, "unreadMessages": 0, "status": "resolved", "flags": [], "lineItems": [ { "id": "4a", "name": "Wireless Mouse", "description": "Wireless Mouse", "amount": -29.99, "account": "3" }, { "id": "4b", "name": "Keyboard", "description": "Keyboard", "amount": -89.99, "account": "3" }, { "id": "4c", "name": "USB Hub", "description": "USB Hub", "amount": -45.99, "account": "3" }, { "id": "4d", "name": "Cable Management", "description": "Cable Management", "amount": -24.02, "account": "3" } ], "type": "purchase", "resolved": true, "class": "5" },
    { "id": "5", "date": "2025-06-04", "vendor": "47", "description": "Mixed business expenses", "amount": -156.78, "account": "5", "suggestedAccount": null, "hasReceipt": false, "messageCount": 3, "unreadMessages": 2, "status": "needs-review", "flags": ["needs-split"], "lineItems": [ { "id": "5a", "name": "Office Snacks", "description": "Office Snacks", "amount": -45.32, "account": "1" }, { "id": "5b", "name": "Cleaning Supplies", "description": "Cleaning Supplies", "amount": -23.45, "account": "2" }, { "id": "5c", "name": "Personal Item", "description": "Personal Item", "amount": -88.01, "account": "8" } ], "type": "purchase", "deep_link": "https://app.xero.com/transactions/5", "resolved": false, "class": "6" },
    { "id": "6", "date": "2025-06-03", "vendor": "36", "description": "Client meeting transportation", "amount": -42.50, "account": "5", "suggestedAccount": "Travel", "hasReceipt": true, "messageCount": 0, "unreadMessages": 0, "status": "resolved", "flags": [], "lineItems": [ { "id": "6a", "name": "Ride to client meeting", "description": "Ride to client meeting", "amount": -42.50, "account": "4" } ], "type": "expense", "resolved": true, "class": "2" },
    { "id": "7", "date": "2025-06-02", "vendor": null, "description": "Payroll accrual entry", "amount": 0.00, "account": null, "suggestedAccount": null, "hasReceipt": false, "messageCount": 0, "unreadMessages": 0, "status": "resolved", "flags": [], "lineItems": [ { "id": "7a", "name": "Wages Expense", "description": "Wages Expense", "amount": -3000.00, "account": "12" }, { "id": "7b", "name": "Payroll Taxes", "description": "Payroll Taxes", "amount": -500.00, "account": "13" }, { "id": "7c", "name": "Accrued Payroll", "description": "Accrued Payroll", "amount": 3500.00, "account": "14" } ], "type": "journal-entry", "deep_link": "https://app.qbo.intuit.com/app/transaction?txnId=7", "resolved": true, "class": "1" },
    { "id": "8", "date": "2025-06-01", "vendor": "43", "description": "Shipping supplies", "amount": -32.50, "account": "2", "suggestedAccount": "Office Supplies", "hasReceipt": true, "messageCount": 0, "unreadMessages": 0, "status": "uncategorized", "flags": ["uncategorized"], "lineItems": [ { "id": "8a", "name": "Boxes", "description": "Boxes", "amount": -20.00, "account": "2" }, { "id": "8b", "name": "Tape", "description": "Tape", "amount": -12.50, "account": "2" } ], "type": "purchase", "deep_link": "https://app.qbo.intuit.com/app/transaction?txnId=8", "resolved": false, "class": "5" }
  ],
  messageTemplates: [
    "Can you provide the receipt for this transaction?",
    "What category should this expense be classified under?",
    "Is this a business or personal expense?",
    "Can you provide more details about this transaction?",
    "Should this be split between multiple categories?"
  ],
  inventory: [
    { id: 1, name: 'Widget A', sku: 'WIDGET-A', quantity: 10, status: 'needs-review', description: 'Missing cost info', resolved: false },
    { id: 2, name: 'Widget B', sku: 'WIDGET-B', quantity: 0, status: 'flagged', description: 'Zero quantity', resolved: false },
  ],
  customers: [
    { id: "1", name: 'Acme Corp', email: 'acme@example.com', status: 'uncategorized', description: 'No contact info', resolved: false },
    { id: "2", name: 'Beta LLC', email: 'beta@example.com', status: 'needs-review', description: 'Duplicate record', resolved: false },
  ],
  glAccounts: [
    { id: "1", name: 'Cash', number: '1000', status: 'resolved', description: 'OK', resolved: true },
    { id: "2", name: 'Inventory', number: '1200', status: 'flagged', description: 'Inactive but has balance', resolved: false },
  ],
  classOptions: [
    { id: "1", name: "Admin" },
    { id: "2", name: "Marketing" },
    { id: "3", name: "Sales" },
    { id: "4", name: "R&D" },
    { id: "5", name: "Operations" },
    { id: "6", name: "Personal" }
  ],
  documents: [
    {
      id: 'doc-1',
      name: 'Monthly Close Report',
      pages: [
        {
          id: 'page-1',
          title: 'Executive Summary',
          blocks: [
            {
              id: 'block-1a',
              type: 'heading',
              content: { text: 'Executive Summary', level: 1 }
            },
            {
              id: 'block-1b',
              type: 'text',
              content: { text: '{{AI_SUMMARY}}' }
            },
            {
              id: 'block-1c',
              type: 'heading',
              content: { text: 'Key Highlights', level: 2 }
            },
            {
              id: 'block-1d',
              type: 'text',
              content: { text: '• Revenue reached $23,035, representing a strong 12.5% increase from the previous month\n• Net income of $7,285 demonstrates healthy profitability with a 38.2% improvement\n• Total assets grew to $85,432, reflecting solid financial position\n• Landscaping services continue to be our primary revenue driver at $17,835' }
            },
            {
              id: 'block-1e',
              type: 'heading',
              content: { text: 'Strategic Focus Areas', level: 2 }
            },
            {
              id: 'block-1f',
              type: 'text',
              content: { text: 'Moving forward, we recommend focusing on expanding our service offerings, optimizing operational expenses, and maintaining our strong cash flow position. The detailed analysis in this report provides actionable insights for continued growth and financial stability.' }
            }
          ]
        },
        {
          id: 'page-3',
          title: 'Financial Summary',
          blocks: [
            {
              id: 'block-2a',
              type: 'text',
              content: { text: 'Financial Summary' },
              isTitle: true
            },
            {
              id: 'block-2b',
              type: 'kpi',
              content: {
                title: 'Key Performance Indicators',
                metrics: [
                  { label: 'Total Revenue', value: '$23,035', change: '+12.5%', trend: 'up' },
                  { label: 'Total Expenses', value: '$15,750', change: '+8.2%', trend: 'up' },
                  { label: 'Net Income', value: '$7,285', change: '+38.2%', trend: 'up' },
                  { label: 'Gross Margin', value: '68.4%', change: '+2.1%', trend: 'up' }
                ]
              }
            },
            {
              id: 'block-2c',
              type: 'chart',
              content: {
                type: 'bar',
                title: 'Monthly Revenue vs Expenses',
                data: sampleData
              }
            },
            {
              id: 'block-2d',
              type: 'text',
              content: { text: 'Key Insights' },
              isTitle: true
            },
            {
              id: 'block-2e',
              type: 'text',
              content: { text: 'December 2024 showed strong financial performance with revenue growth of 12.5% compared to the previous month. The business maintained healthy profit margins while managing controlled expense growth. Key drivers included increased landscaping services revenue and effective cost management across operational categories.' }
            }
          ]
        },
        {
          id: 'page-4',
          title: 'Balance Sheet',
          blocks: [
            {
              id: 'block-3',
              type: 'reportBlock',
              content: {
                reportType: 'balance-sheet',
                title: 'Balance Sheet',
                dateRange: 'As of December 31, 2024',
                data: {
                  summary: {
                    totalAssets: 85432.50,
                    totalLiabilities: 45608.19,
                    totalEquity: 39824.31
                  },
                  accounts: [
                    {
                      accountId: '84',
                      name: 'Accounts Receivable (A/R)',
                      type: 'Accounts Receivable',
                      val: 26195.85,
                      p_l: 0.0,
                      previousMonthval: 24850.00,
                      previousMonthp_l: 0.0,
                      isDebit: true,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '91',
                      name: 'Cash on hand',
                      type: 'Bank',
                      val: 965.0,
                      p_l: 0.0,
                      previousMonthval: 1200.0,
                      previousMonthp_l: 0.0,
                      isDebit: false,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '35',
                      name: 'Checking',
                      type: 'Bank',
                      val: 18326.7,
                      p_l: 0.0,
                      previousMonthval: 16500.0,
                      previousMonthp_l: 0.0,
                      isDebit: false,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '81',
                      name: 'Inventory Asset',
                      type: 'Other Current Asset',
                      val: 516.25,
                      p_l: 0.0,
                      previousMonthval: 425.50,
                      previousMonthp_l: 0.0,
                      isDebit: true,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '77',
                      name: 'Trucks',
                      type: 'Fixed Asset',
                      val: 0.0,
                      p_l: 0.0,
                      previousMonthval: 0.0,
                      previousMonthp_l: 0.0,
                      isDebit: true,
                      sub: [
                        {
                          accountId: '78',
                          name: 'Original cost',
                          type: 'Fixed Asset',
                          val: 25000.0,
                          p_l: 0.0,
                          previousMonthval: 25000.0,
                          previousMonthp_l: 0.0,
                          isDebit: true,
                          sub: [],
                          parent: '77'
                        },
                        {
                          accountId: '79',
                          name: 'Depreciation',
                          type: 'Fixed Asset',
                          val: -10571.3,
                          p_l: 0.0,
                          previousMonthval: -9850.0,
                          previousMonthp_l: 0.0,
                          isDebit: true,
                          sub: [],
                          parent: '77'
                        }
                      ],
                      parent: null
                    },
                    {
                      accountId: '33',
                      name: 'Accounts Payable (A/P)',
                      type: 'Accounts Payable',
                      val: 40608.19,
                      p_l: 0.0,
                      previousMonthval: 38200.0,
                      previousMonthp_l: 0.0,
                      isDebit: false,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '90',
                      name: 'Board of Equalization Payable',
                      type: 'Other Current Liability',
                      val: 1816.7,
                      p_l: 0.0,
                      previousMonthval: 1650.0,
                      previousMonthp_l: 0.0,
                      isDebit: false,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '80',
                      name: 'Notes Payable',
                      type: 'Long Term Liability',
                      val: 3183.3,
                      p_l: 0.0,
                      previousMonthval: 3500.0,
                      previousMonthp_l: 0.0,
                      isDebit: false,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '34',
                      name: 'Opening Balance Equity',
                      type: 'Equity',
                      val: 9337.5,
                      p_l: 0.0,
                      previousMonthval: 9337.5,
                      previousMonthp_l: 0.0,
                      isDebit: true,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '72',
                      name: 'Retained Earnings',
                      type: 'Equity',
                      val: 30486.81,
                      p_l: 0.0,
                      previousMonthval: 28950.0,
                      previousMonthp_l: 0.0,
                      isDebit: false,
                      sub: [],
                      parent: null
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          id: 'page-5',
          title: 'Profit & Loss Statement',
          blocks: [
            {
              id: 'block-4',
              type: 'reportBlock',
              content: {
                reportType: 'profit-loss',
                title: 'Profit & Loss Statement',
                dateRange: 'December 2024',
                data: {
                  summary: {
                    totalRevenue: 23035,
                    totalExpenses: 15750,
                    netIncome: 7285
                  },
                  accounts: [
                    {
                      accountId: '45',
                      name: 'Landscaping Services',
                      type: 'Income',
                      val: 0.0,
                      p_l: 17835,
                      previousMonthval: 0.0,
                      previousMonthp_l: 16200,
                      isDebit: false,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '85',
                      name: 'Billable Expense Income',
                      type: 'Income',
                      val: 0.0,
                      p_l: 5200,
                      previousMonthval: 0.0,
                      previousMonthp_l: 4850,
                      isDebit: false,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '7',
                      name: 'Advertising',
                      type: 'Expense',
                      val: 0.0,
                      p_l: 900,
                      previousMonthval: 0.0,
                      previousMonthp_l: 1100,
                      isDebit: false,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '58',
                      name: 'Job Expenses',
                      type: 'Expense',
                      val: 0.0,
                      p_l: 0.0,
                      previousMonthval: 0.0,
                      previousMonthp_l: 0.0,
                      isDebit: false,
                      sub: [
                        {
                          accountId: '59',
                          name: 'Cost of Labor',
                          type: 'Expense',
                          val: 0.0,
                          p_l: 0.0,
                          previousMonthval: 0.0,
                          previousMonthp_l: 0.0,
                          isDebit: false,
                          sub: [
                            {
                              accountId: '60',
                              name: 'Installation',
                              type: 'Expense',
                              val: 0.0,
                              p_l: 4500,
                              previousMonthval: 0.0,
                              previousMonthp_l: 4200,
                              isDebit: false,
                              sub: [],
                              parent: '59'
                            },
                            {
                              accountId: '61',
                              name: 'Maintenance and Repairs',
                              type: 'Expense',
                              val: 0.0,
                              p_l: 3900,
                              previousMonthval: 0.0,
                              previousMonthp_l: 3600,
                              isDebit: false,
                              sub: [],
                              parent: '59'
                            }
                          ],
                          parent: '58'
                        },
                        {
                          accountId: '62',
                          name: 'Equipment Rental',
                          type: 'Expense',
                          val: 0.0,
                          p_l: 4200,
                          previousMonthval: 0.0,
                          previousMonthp_l: 3800,
                          isDebit: false,
                          sub: [],
                          parent: '58'
                        }
                      ],
                      parent: null
                    },
                    {
                      accountId: '55',
                      name: 'Automobile',
                      type: 'Expense',
                      val: 0.0,
                      p_l: 0.0,
                      previousMonthval: 0.0,
                      previousMonthp_l: 0.0,
                      isDebit: false,
                      sub: [
                        {
                          accountId: '56',
                          name: 'Fuel',
                          type: 'Expense',
                          val: 0.0,
                          p_l: 1800,
                          previousMonthval: 0.0,
                          previousMonthp_l: 1650,
                          isDebit: false,
                          sub: [],
                          parent: '55'
                        }
                      ],
                      parent: null
                    },
                    {
                      accountId: '8',
                      name: 'Bank Charges',
                      type: 'Expense',
                      val: 0.0,
                      p_l: 450,
                      previousMonthval: 0.0,
                      previousMonthp_l: 420,
                      isDebit: false,
                      sub: [],
                      parent: null
                    },
                    {
                      accountId: '50',
                      name: 'Office Supplies',
                      type: 'Expense',
                      val: 0.0,
                      p_l: 500,
                      previousMonthval: 0.0,
                      previousMonthp_l: 600,
                      isDebit: false,
                      sub: [],
                      parent: null
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          id: 'page-6',
          title: 'Drill Down Analysis',
          blocks: [
            {
              id: 'block-5',
              type: 'table',
              content: {
                title: 'Balance Sheet',
                headers: ['Category', 'Dec 2024', 'Nov 2024', 'Change'],
                rows: [
                  ['Assets', '$120,000', '$115,000', '+4.3%'],
                  ['Liabilities', '$50,000', '$48,000', '+4.2%'],
                  ['Equity', '$70,000', '$67,000', '+4.5%']
                ]
              }
            }
          ]
        },
        {
          id: 'page-7',
          title: 'Risks and Opportunities',
          blocks: [
            {
              id: 'block-6a',
              type: 'text',
              content: { text: 'Based on the financial data and typical business considerations, here are three risks and three opportunities for this business:' }
            },
            {
              id: 'block-6b',
              type: 'heading',
              content: { text: 'Risks', level: 2 }
            },
            {
              id: 'block-6c',
              type: 'text',
              content: { text: '1. Negative or volatile net income - With some periods showing a net operating loss (-225), the business faces a risk of unsteady profitability that could impact cash flow and sustainability.<br />2. High promotional expenses - A significant promotional expense ($900 in one period) with no clear corresponding revenue increase could risk inefficient use of marketing budgets.<br />3. Dependency on limited income sources - Income is concentrated in landscaping services and a few other small income lines, which could risk revenue stability if demand changes.' }
            },
            {
              id: 'block-6d',
              type: 'heading',
              content: { text: 'Opportunities', level: 2 }
            },
            {
              id: 'block-6e',
              type: 'text',
              content: { text: '1. Strong gross profit on landscaping services - Significant income ($17,835) with zero cost of goods sold suggests high margin potential that could be expanded.<br />2. Potential to optimize expenses - With some uncategorized and variable expenses present, improving cost management could boost profitability.<br />3. Room to diversify income - Adding more service types or products could reduce dependency on a narrow income base and stabilize revenue streams.' }
            },
            {
              id: 'block-6f',
              type: 'text',
              content: { text: 'These insights derive from the P&L data showing income, expenses, and net operating income trends, highlighting areas of financial strength and concern for the business.' }
            }
          ]
        }
      ]
    },
    {
      id: 'doc-2',
      name: 'Financial Dashboard Demo',
      pages: [
        {
          id: 'dashboard-page-1',
          title: 'Financial Dashboard',
          blocks: [
            {
              id: 'dashboard-intro',
              type: 'heading',
              content: { text: 'Financial Dashboard', level: 1 }
            },
            {
              id: 'dashboard-description',
              type: 'text',
              content: { text: 'This comprehensive financial dashboard provides a real-time view of your business performance with interactive charts, key metrics, and forward-looking insights.' }
            },
            {
              id: 'dashboard-insights',
              type: 'heading',
              content: { text: 'Key Insights', level: 2 }
            },
            {
              id: 'dashboard-insights-text',
              type: 'text',
              content: { text: 'The dashboard shows strong financial performance with revenue growth of 12.2% and healthy cash flow projections. The 90-day cash forecast indicates stable liquidity with projected ending balance of $146,000.' }
            }
          ]
        }
      ]
    }
  ]
};

export const templates = [
  { id: 'monthly-close', name: 'Monthly Close Summary', icon: 'Calendar', description: 'Comprehensive monthly financial close report' },
  { id: 'cleanup-progress', name: 'Cleanup Progress Report', icon: 'TrendingUp', description: 'Track bookkeeping cleanup activities' },
  { id: 'kpi-snapshot', name: 'KPI Snapshot', icon: 'BarChart3', description: 'Quick overview of key metrics' },
  { id: 'advisory-insights', name: 'Advisory Insights', icon: 'Sparkles', description: 'Strategic recommendations and insights' },
  { id: 'quarterly-report', name: 'Quarterly Financial Report', icon: 'PieChart', description: 'Comprehensive quarterly financial report with analysis' },
  { id: 'investor-presentation', name: 'Investor Presentation', icon: 'TrendingUp', description: 'Professional investor presentation deck' },
  { id: 'board-meeting', name: 'Board Meeting Deck', icon: 'Users', description: 'Board meeting presentation with strategic updates' },
  { id: 'blank-page', name: 'Blank Page', icon: 'File', description: 'Start with an empty page' }
];

export const pageTemplates = [
  {
    id: 'cover-page',
    name: 'Cover Page',
    icon: 'FileText',
    description: 'Professional cover page with title and company info',
    blocks: [
      { id: 'cover-1', type: 'text', content: { text: 'Financial Report' }, isTitle: true },
      { id: 'cover-2', type: 'text', content: { text: 'December 2024' } },
      { id: 'cover-3', type: 'divider', content: {} },
      { id: 'cover-4', type: 'text', content: { text: 'Prepared for: [Client Name]\nPrepared by: [Your Company]\nDate: [Current Date]' } }
    ]
  },
  {
    id: 'financial-summary',
    name: 'Financial Summary',
    icon: 'BarChart',
    description: 'Overview of financial performance',
    blocks: [
      { id: 'summary-1', type: 'text', content: { text: 'Financial Summary' }, isTitle: true },
      { id: 'summary-2', type: 'kpi', content: { metrics: ['totalRevenue', 'totalExpenses', 'netIncome'] } },
      { id: 'summary-3', type: 'chart', content: { type: 'bar', data: sampleData } },
      { id: 'summary-4', type: 'text', content: { text: 'Key Insights:' }, isTitle: true },
      { id: 'summary-5', type: 'text', content: { text: '[AI Insights Here]' }, isEditable: true }
    ]
  }
  ,
  {
    id: 'blank-page',
    name: 'Blank Page',
    icon: 'File', // Changed to 'File' for blank page
    description: 'New Blank Page',
    blocks: [
      { id: 'blank-1', type: 'text', content: { text: '' }, isTitle: false, isEditable: true },
    ]
  }
];

export const slashMenuItems = [
  // Content Blocks
  { type: 'text', icon: 'Type', label: 'Text', category: 'content', description: 'Rich text with formatting' },
  { type: 'ai', icon: 'Brain', label: 'AI Content', category: 'content', description: 'AI-generated content with custom prompts' },
  { type: 'title', icon: 'Heading1', label: 'Title', category: 'content', description: 'Large document title' },
  { type: 'heading', icon: 'Hash', label: 'Heading', category: 'content', description: 'Section heading' },
  
  // Data & Visualization
  { type: 'kpi', icon: 'TrendingUp', label: 'KPIs', category: 'data', description: 'Key performance indicators' },
  { type: 'chart', icon: 'BarChart3', label: 'Chart', category: 'data', description: 'Interactive data visualization' },
  { type: 'table', icon: 'Table', label: 'Table', category: 'data', description: 'Sortable data table' },
  { type: 'reportBlock', icon: 'FileText', label: 'Financial Report', category: 'data', description: 'Detailed financial data' },
  
  // Layout Containers
  { type: 'card-container', icon: 'Square', label: 'Card Grid', category: 'layout', description: 'Grid of cards' },
  { type: 'hero-section', icon: 'Maximize', label: 'Hero Section', category: 'layout', description: 'Large featured content' },
  
  // Interactive Elements
  
  // Media Blocks
  { type: 'video', icon: 'Video', label: 'Video', category: 'media', description: 'Embed video content' },
  { type: 'image', icon: 'Image', label: 'Image', category: 'media', description: 'Upload or embed images' },
  
  // Utility
  { type: 'quote', icon: 'Quote', label: 'Quote', category: 'utility', description: 'Highlighted quote' },
  { type: 'divider', icon: 'Code', label: 'Divider', category: 'utility', description: 'Visual separator' }
];

export const aiSuggestions = [
  // Quick Content Generation
  { prompt: 'Summarize the financial performance', icon: 'TrendingUp', category: 'content' },
  { prompt: 'Write an executive summary', icon: 'FileText', category: 'content' },
  { prompt: 'Explain key trends and insights', icon: 'Brain', category: 'content' },
  { prompt: 'Generate recommendations', icon: 'Sparkles', category: 'content' },
  { prompt: 'Create a conclusion', icon: 'Check', category: 'content' },
  { prompt: 'Write an introduction', icon: 'Type', category: 'content' },
  
  // Advanced Document Generation
  { prompt: 'Generate complete quarterly report', icon: 'FileText', category: 'document', advanced: true },
  { prompt: 'Create investor presentation', icon: 'Presentation', category: 'document', advanced: true },
  { prompt: 'Build board meeting deck', icon: 'Users', category: 'document', advanced: true },
  { prompt: 'Generate budget proposal', icon: 'DollarSign', category: 'document', advanced: true },
  
  // Content Enhancement
  { prompt: 'Make this sound more professional', icon: 'Edit', category: 'enhance', enhance: true },
  { prompt: 'Adjust tone to be more formal', icon: 'FileText', category: 'enhance', enhance: true },
  { prompt: 'Simplify for executive audience', icon: 'Users', category: 'enhance', enhance: true },
  { prompt: 'Add more detail and context', icon: 'Plus', category: 'enhance', enhance: true },
  
  // Data-Driven Suggestions
  { prompt: 'Analyze revenue trends', icon: 'TrendingUp', category: 'data' },
  { prompt: 'Compare period over period', icon: 'BarChart3', category: 'data' },
  { prompt: 'Identify cost reduction opportunities', icon: 'TrendingDown', category: 'data' },
  { prompt: 'Highlight key metrics', icon: 'Target', category: 'data' }
];

// AI Capabilities for different contexts
export const AI_CAPABILITIES = {
  GENERATE_DOCUMENT: 'document',
  ENHANCE_TEXT: 'enhance', 
  SUGGEST_LAYOUT: 'layout',
  CREATE_VISUALIZATIONS: 'viz',
  SUMMARIZE_DATA: 'summary',
  PROFESSIONAL_TONE: 'tone',
  STRATEGIC_INSIGHTS: 'insights'
};

// Document templates for AI generation
export const documentTemplates = {
  'quarterly-report': {
    name: 'Quarterly Financial Report',
    prompt: 'Generate a comprehensive quarterly financial report including executive summary, financial highlights, key metrics, trends analysis, and outlook',
    blocks: [
      { type: 'title', content: { text: 'Q[X] [YEAR] Financial Report' } },
      { type: 'text', aiGenerated: true, prompt: 'executive-summary' },
      { type: 'kpi', content: { title: 'Key Financial Metrics', metrics: [] } },
      { type: 'chart', content: { title: 'Revenue Trend', chartType: 'line' } },
      { type: 'text', aiGenerated: true, prompt: 'financial-analysis' },
      { type: 'table', content: { title: 'Financial Statement Summary' } },
      { type: 'text', aiGenerated: true, prompt: 'outlook-recommendations' }
    ]
  },
  
  'investor-presentation': {
    name: 'Investor Presentation',
    prompt: 'Create an investor presentation covering company overview, market opportunity, financial performance, growth strategy, and funding needs',
    blocks: [
      { type: 'hero-section', content: { title: 'Company Name', subtitle: 'Investor Presentation' } },
      { type: 'text', aiGenerated: true, prompt: 'company-overview' },
      { type: 'chart', content: { title: 'Market Size & Opportunity' } },
      { type: 'kpi', content: { title: 'Key Business Metrics' } },
      { type: 'text', aiGenerated: true, prompt: 'growth-strategy' },
      { type: 'chart', content: { title: 'Financial Projections' } },
      { type: 'text', aiGenerated: true, prompt: 'funding-requirements' }
    ]
  },

  'board-meeting': {
    name: 'Board Meeting Deck', 
    prompt: 'Generate board meeting presentation with strategic updates, financial performance, key decisions needed, and operational highlights',
    blocks: [
      { type: 'title', content: { text: 'Board Meeting - [Date]' } },
      { type: 'text', aiGenerated: true, prompt: 'agenda-overview' },
      { type: 'text', content: { text: 'Financial Update: [Content]' } },
      { type: 'text', content: { text: 'Operations: [Content]' } },
      { type: 'text', content: { text: 'Strategy: [Content]' } },
      { type: 'kpi', content: { title: 'Key Performance Indicators' } },
      { type: 'text', aiGenerated: true, prompt: 'decisions-needed' }
    ]
  }
};

export const templateBlocks = {
  'monthly-close': [
    // Cover Page
    {
      title: 'Cover Page',
      blocks: [
        { 
          id: 'cover-hero', 
          type: 'hero-section', 
          content: { 
            title: '{{COMPANY_NAME}}',
            subtitle: 'Monthly Financial Report - {{CURRENT_MONTH}} {{CURRENT_YEAR}}',
            backgroundColor: '#1e40af',
            textColor: '#ffffff',
            alignment: 'center'
          } 
        },
        { 
          id: 'cover-info', 
          type: 'text', 
          content: { 
            text: 'Prepared by: {{PREPARED_BY}}\nReport Date: {{REPORT_DATE}}\nPeriod: {{CURRENT_MONTH}} {{CURRENT_YEAR}}' 
          } 
        }
      ]
    },
    // Executive Summary
    {
      title: 'Executive Summary',
      blocks: [
        { id: 'exec-title', type: 'heading', content: { text: 'Executive Summary', level: 1 } },
        { 
          id: 'exec-kpis', 
          type: 'kpi', 
          content: {
            title: 'Monthly Performance Highlights',
            metrics: [
              { label: 'Revenue', value: '{{REVENUE}}', change: '{{REVENUE_CHANGE}}', trend: 'up' },
              { label: 'Net Income', value: '{{NET_INCOME}}', change: '{{INCOME_CHANGE}}', trend: 'up' },
              { label: 'Cash on Hand', value: '{{CASH_ON_HAND}}', change: '{{CASH_CHANGE}}', trend: 'up' },
              { label: 'Gross Margin', value: '{{GROSS_MARGIN}}', change: '{{MARGIN_CHANGE}}', trend: 'up' }
            ]
          }
        },
        { 
          id: 'exec-summary-text', 
          type: 'text', 
          content: { 
            text: '{{AI_SUMMARY}}'
          }
        }
      ]
    },
    // Financial Performance Dashboard
    {
      title: 'Financial Performance',
      blocks: [
        { id: 'perf-title', type: 'heading', content: { text: 'Financial Performance Dashboard', level: 1 } },
        {
          id: 'revenue-expense-chart',
          type: 'chart',
          content: {
            title: 'Revenue vs Expenses Trend',
            chartType: 'combo',
            data: {
              labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
              datasets: [
                {
                  label: 'Revenue',
                  data: [18000, 19500, 20000, 21000, 20500, 23035],
                  backgroundColor: 'rgba(75, 192, 192, 0.6)',
                  type: 'bar'
                },
                {
                  label: 'Expenses',
                  data: [16000, 17000, 16500, 17500, 18000, 15750],
                  backgroundColor: 'rgba(255, 99, 132, 0.6)',
                  type: 'bar'
                },
                {
                  label: 'Net Income',
                  data: [2000, 2500, 3500, 3500, 2500, 7285],
                  borderColor: 'rgb(54, 162, 235)',
                  backgroundColor: 'rgba(54, 162, 235, 0.2)',
                  type: 'line'
                }
              ]
            }
          }
        },
        {
          id: 'cash-flow-chart',
          type: 'chart',
          content: {
            title: 'Cash Flow Analysis',
            chartType: 'bar',
            data: {
              labels: ['Opening Balance', 'Operating Income', 'Operating Expenses', 'Investing', 'Financing', 'Ending Balance'],
              datasets: [{
                label: 'Cash Flow',
                data: [50000, 25000, -20000, -3000, 2000, 54000],
                backgroundColor: ['#3b82f6', '#10b981', '#ef4444', '#ef4444', '#10b981', '#3b82f6']
              }]
            }
          }
        }
      ]
    },
    // Profit & Loss
    {
      title: 'Profit & Loss',
      blocks: [
        { id: 'pl-title', type: 'heading', content: { text: 'Profit & Loss', level: 1 } },
        { id: 'pl-subtitle', type: 'text', content: { text: 'For the month ended {{MONTH_END_DATE}}' } },
        { 
          id: 'pl-report', 
          type: 'reportBlock', 
          content: {
            reportType: 'profit-loss',
            title: 'Profit & Loss Statement',
            dateRange: '{{CURRENT_MONTH}} {{CURRENT_YEAR}}'
          }
        }
      ]
    },
    // Balance Sheet
    {
      title: 'Balance Sheet',
      blocks: [
        { id: 'bs-title', type: 'heading', content: { text: 'Balance Sheet', level: 1 } },
        { id: 'bs-subtitle', type: 'text', content: { text: 'As of {{MONTH_END_DATE}}' } },
        { 
          id: 'bs-report', 
          type: 'reportBlock', 
          content: {
            reportType: 'balance-sheet',
            title: 'Balance Sheet',
            dateRange: 'As of {{MONTH_END_DATE}}'
          }
        }
      ]
    },
    // Trial Balance
    {
      title: 'Trial Balance',
      blocks: [
        { id: 'tb-title', type: 'heading', content: { text: 'Trial Balance', level: 1 } },
        { id: 'tb-subtitle', type: 'text', content: { text: 'As of {{MONTH_END_DATE}}' } },
        { 
          id: 'tb-report', 
          type: 'reportBlock', 
          content: {
            reportType: 'trial-balance',
            title: 'Trial Balance',
            dateRange: 'As of {{MONTH_END_DATE}}'
          }
        }
      ]
    },
    // Advisory Insights
    {
      title: 'Advisory Insights',
      blocks: [
        { id: 'insights-title', type: 'heading', content: { text: 'Strategic Insights & Recommendations', level: 1 } },
        { 
          id: 'health-indicators', 
          type: 'kpi', 
          content: {
            title: 'Business Health Indicators',
            metrics: [
              { label: 'Overall Health', value: '{{OVERALL_HEALTH}}' },
              { label: 'Cash Flow Outlook', value: '{{CASH_FLOW_OUTLOOK}}' }
            ]
          }
        },
        { id: 'insights-subtitle', type: 'heading', content: { text: 'Opportunities', level: 2 } },
        {
          id: 'opportunities',
          type: 'text',
          content: { text: '{{AI_OPPORTUNITIES}}' }
        },
        { id: 'risks-subtitle', type: 'heading', content: { text: 'Risk Factors', level: 2 } },
        {
          id: 'risks',
          type: 'text',
          content: { text: '{{AI_RISKS}}' }
        },
        { id: 'anomalies-subtitle', type: 'heading', content: { text: 'Anomalies & Attention Points', level: 2 } },
        {
          id: 'anomalies',
          type: 'text',
          content: { text: '{{AI_ANOMALIES}}' }
        }
      ]
    }
  ],
  'cleanup-progress': [
    {
      title: 'Cleanup Overview',
      blocks: [
        { id: 'cleanup-1', type: 'kpi', content: {
          title: 'Cleanup Progress Metrics',
          metrics: [
            { label: 'Total Revenue', value: '$45,230', change: '+12.5%', trend: 'up' },
            { label: 'Gross Margin', value: '68.2%', change: '+2.1%', trend: 'up' },
            { label: 'Outstanding AR', value: '$8,950', change: '-5.3%', trend: 'down' }
          ]
        } }
      ]
    },
    {
      title: 'Profit & Loss Statement',
      blocks: [
        { id: 'pnl-1', type: 'table', content: {
          title: 'Profit & Loss Statement',
          headers: ['Account', 'Dec 2024', 'Nov 2024', 'Change'],
          rows: [
            ['Total Revenue', '$45,230', '$40,185', '+12.5%'],
            ['Cost of Goods Sold', '$18,500', '$17,200', '+7.6%'],
            ['Gross Profit', '$26,730', '$22,985', '+16.3%'],
            ['Operating Expenses', '$15,000', '$14,500', '+3.4%'],
            ['Net Income', '$11,730', '$8,485', '+38.2%']
          ]
        } }
      ]
    },
    {
      title: 'Balance Sheet',
      blocks: [
        { id: 'balance-sheet-1', type: 'table', content: {
          title: 'Balance Sheet',
          headers: ['Category', 'Dec 2024', 'Nov 2024', 'Change'],
          rows: [
            ['Assets', '$120,000', '$115,000', '+4.3%'],
            ['Liabilities', '$50,000', '$48,000', '+4.2%'],
            ['Equity', '$70,000', '$67,000', '+4.5%']
          ]
        } }
      ]
    },
    {
      title: 'Risks and Opportunities',
      blocks: [
        { id: 'risks-1', type: 'text', content: { text: 'Risks and Opportunities: Key risks include market volatility and supply chain disruptions. Opportunities include expanding into new markets and leveraging technology for operational efficiency.' } }
      ]
    }
  ],
  'cleanup-progress': [
    {
      title: 'Cleanup Progress Overview',
      blocks: [
        { id: 'cleanup-1', type: 'text', content: { text: 'Bookkeeping Cleanup Progress Report' }, isTitle: true },
        { id: 'cleanup-2', type: 'text', content: { text: 'This report outlines the progress made during our bookkeeping cleanup initiative, highlighting completed tasks and remaining work.' } }
      ]
    },
    {
      title: 'Metrics',
      blocks: [
        { id: 'cleanup-metrics-1', type: 'kpi', content: {
          title: 'Cleanup Progress Metrics',
          metrics: [
            { label: 'Transactions Reviewed', value: '2,847', change: '+95%', trend: 'up' },
            { label: 'Errors Corrected', value: '156', change: '-23%', trend: 'down' },
            { label: 'Days Remaining', value: '12', change: '-40%', trend: 'down' }
          ]
        } }
      ]
    }
  ],
  'kpi-snapshot': [
    {
      title: 'Key Metrics Overview',
      blocks: [
        { id: 'kpi-metrics-1', type: 'kpi', content: {
          title: 'Key Metrics',
          metrics: [
            { label: 'Revenue Growth', value: '+15%', trend: 'up' },
            { label: 'Customer Retention', value: '92%', trend: 'up' },
            { label: 'Net Profit Margin', value: '18%', trend: 'up' }
          ]
        } }
      ]
    }
  ],
  'advisory-insights': [
    {
      title: 'Cover Page',
      blocks: [
        { id: 'advisory-cover-1', type: 'hero-section', content: { 
          title: '{{COMPANY_NAME}}',
          subtitle: 'Strategic Advisory Report - {{CURRENT_MONTH}} {{CURRENT_YEAR}}',
          backgroundColor: '#059669',
          textColor: '#ffffff',
          alignment: 'center'
        } },
        { id: 'advisory-cover-2', type: 'text', content: { text: 'Prepared by: {{PREPARED_BY}}\nReport Date: {{REPORT_DATE}}' } }
      ]
    },
    {
      title: 'Strategic Insights',
      blocks: [
        { id: 'advisory-title', type: 'heading', content: { text: 'Strategic Insights & Analysis', level: 1 } },
        { 
          id: 'advisory-health', 
          type: 'kpi', 
          content: {
            title: 'Business Health Assessment',
            metrics: [
              { label: 'Overall Business Health', value: '{{OVERALL_HEALTH}}' },
              { label: '90-Day Cash Flow Outlook', value: '{{CASH_FLOW_OUTLOOK}}' }
            ]
          }
        },
        { id: 'advisory-summary-title', type: 'heading', content: { text: 'Executive Analysis', level: 2 } },
        { id: 'advisory-summary', type: 'text', content: { text: '{{AI_SUMMARY}}' } }
      ]
    },
    {
      title: 'Opportunities and Risks',
      blocks: [
        { id: 'advisory-opp-title', type: 'heading', content: { text: 'Growth Opportunities', level: 2 } },
        { id: 'advisory-opportunities', type: 'text', content: { text: '{{AI_OPPORTUNITIES}}' } },
        { id: 'advisory-risk-title', type: 'heading', content: { text: 'Risk Assessment', level: 2 } },
        { id: 'advisory-risks', type: 'text', content: { text: '{{AI_RISKS}}' } },
        { id: 'advisory-anomaly-title', type: 'heading', content: { text: 'Items Requiring Attention', level: 2 } },
        { id: 'advisory-anomalies', type: 'text', content: { text: '{{AI_ANOMALIES}}' } }
      ]
    }
  ],
  'quarterly-report': [
    {
      title: 'Cover Page',
      blocks: [
        { 
          id: 'quarterly-hero', 
          type: 'hero-section', 
          content: { 
            title: '{{COMPANY_NAME}}',
            subtitle: 'Q{{CURRENT_QUARTER}} {{CURRENT_YEAR}} Financial Report - Comprehensive quarterly financial analysis and performance review',
            backgroundColor: '#7c3aed',
            textColor: '#ffffff',
            alignment: 'center'
          } 
        },
        { id: 'quarterly-company', type: 'text', content: { text: 'Prepared by: {{PREPARED_BY}}\nDate: {{REPORT_DATE}}' } }
      ]
    },
    {
      title: 'Executive Summary',
      blocks: [
        { id: 'quarterly-exec-heading', type: 'heading', content: { text: 'Executive Summary', level: 1 } },
        { id: 'quarterly-exec-text', type: 'text', content: { text: '{{AI_SUMMARY}}' } }
      ]
    },
    {
      title: 'Key Financial Metrics',
      blocks: [
        { id: 'quarterly-kpi-heading', type: 'heading', content: { text: 'Key Financial Metrics', level: 1 } },
        { 
          id: 'quarterly-kpi', 
          type: 'kpi', 
          content: {
            title: 'Quarterly Performance Highlights',
            metrics: [
              { label: 'Quarterly Revenue', value: '{{REVENUE}}', change: '{{REVENUE_CHANGE}}', trend: 'up' },
              { label: 'Net Income', value: '{{NET_INCOME}}', change: '{{INCOME_CHANGE}}', trend: 'up' },
              { label: 'Operating Margin', value: '{{GROSS_MARGIN}}', change: '{{MARGIN_CHANGE}}', trend: 'up' },
              { label: 'Cash Position', value: '{{CASH_ON_HAND}}', change: '{{CASH_CHANGE}}', trend: 'up' }
            ]
          }
        }
      ]
    },
    {
      title: 'Revenue Trend Analysis',
      blocks: [
        { id: 'quarterly-trend-heading', type: 'heading', content: { text: 'Revenue Trend Analysis', level: 1 } },
        { id: 'quarterly-chart', type: 'chart', content: { title: 'Quarterly Revenue Trend', chartType: 'line' } },
        { id: 'quarterly-analysis', type: 'text', content: { text: 'Detailed analysis of revenue trends, seasonal patterns, and growth drivers across the quarter.' } }
      ]
    },
    {
      title: 'Financial Statement Summary',
      blocks: [
        { id: 'quarterly-table-heading', type: 'heading', content: { text: 'Financial Statement Summary', level: 1 } },
        { 
          id: 'quarterly-table', 
          type: 'reportBlock', 
          content: {
            reportType: 'profit-loss',
            title: 'Profit & Loss - Quarterly View',
            dateRange: 'Q{{CURRENT_QUARTER}} {{CURRENT_YEAR}}'
          }
        }
      ]
    },
    {
      title: 'Outlook & Recommendations',
      blocks: [
        { id: 'quarterly-outlook-heading', type: 'heading', content: { text: 'Outlook & Strategic Recommendations', level: 1 } },
        { id: 'quarterly-outlook', type: 'text', content: { text: 'Forward-looking insights including market outlook, strategic recommendations, and key initiatives for the upcoming quarter.' } }
      ]
    }
  ],
  'investor-presentation': [
    {
      title: 'Title Slide',
      blocks: [
        { 
          id: 'investor-hero', 
          type: 'hero-section', 
          content: { 
            title: '{{COMPANY_NAME}}',
            subtitle: 'Investor Presentation - {{CURRENT_MONTH}} {{CURRENT_YEAR}}',
            backgroundColor: '#1e40af',
            textColor: '#ffffff',
            alignment: 'center'
          } 
        },
        { id: 'investor-tagline', type: 'text', content: { text: 'Transforming the industry through innovation and strategic growth' } }
      ]
    },
    {
      title: 'Company Overview',
      blocks: [
        { id: 'investor-overview-heading', type: 'heading', content: { text: 'Company Overview', level: 1 } },
        { id: 'investor-overview-text', type: 'text', content: { text: '{{AI_SUMMARY}}' } },
        { 
          id: 'investor-company-kpi', 
          type: 'kpi', 
          content: {
            title: 'Company Snapshot',
            metrics: [
              { label: 'Founded', value: '2020', trend: 'neutral' },
              { label: 'Employees', value: '150+', trend: 'up' },
              { label: 'Market Reach', value: 'Global', trend: 'up' }
            ]
          }
        }
      ]
    },
    {
      title: 'Market Opportunity',
      blocks: [
        { id: 'investor-market-heading', type: 'heading', content: { text: 'Market Size & Opportunity', level: 1 } },
        { id: 'investor-market-chart', type: 'chart', content: { title: 'Total Addressable Market (TAM)', chartType: 'bar' } },
        { id: 'investor-market-text', type: 'text', content: { text: 'Analysis of market size, growth potential, competitive positioning, and our strategic approach to market capture.' } }
      ]
    },
    {
      title: 'Business Metrics',
      blocks: [
        { id: 'investor-metrics-heading', type: 'heading', content: { text: 'Key Business Metrics', level: 1 } },
        { 
          id: 'investor-business-kpi', 
          type: 'kpi', 
          content: {
            title: 'Performance Indicators',
            metrics: [
              { label: 'Annual Revenue', value: '{{REVENUE}}', change: '{{REVENUE_CHANGE}}', trend: 'up' },
              { label: 'Customer Growth', value: '+45%', change: '+12%', trend: 'up' },
              { label: 'Market Share', value: '8.2%', change: '+2.1%', trend: 'up' },
              { label: 'Profit Margin', value: '{{GROSS_MARGIN}}', change: '{{MARGIN_CHANGE}}', trend: 'up' }
            ]
          }
        }
      ]
    },
    {
      title: 'Growth Strategy',
      blocks: [
        { id: 'investor-strategy-heading', type: 'heading', content: { text: 'Growth Strategy & Roadmap', level: 1 } },
        { id: 'investor-strategy-text', type: 'text', content: { text: 'Our comprehensive growth strategy covering market expansion, product development, strategic partnerships, and scaling operations.' } }
      ]
    },
    {
      title: 'Financial Projections',
      blocks: [
        { id: 'investor-projections-heading', type: 'heading', content: { text: 'Financial Projections', level: 1 } },
        { id: 'investor-projections-chart', type: 'chart', content: { title: '3-Year Revenue & Profitability Forecast', chartType: 'line' } },
        { id: 'investor-projections-text', type: 'text', content: { text: 'Detailed financial projections including revenue growth, profitability targets, and key assumptions driving our forecast.' } }
      ]
    },
    {
      title: 'Investment Summary',
      blocks: [
        { id: 'investor-funding-heading', type: 'heading', content: { text: 'Investment Opportunity', level: 1 } },
        { id: 'investor-funding-text', type: 'text', content: { text: 'Investment requirements, use of funds, expected timeline, investor benefits, and projected returns on investment.' } }
      ]
    }
  ],
  'board-meeting': [
    {
      title: 'Title & Agenda',
      blocks: [
        { 
          id: 'board-hero', 
          type: 'hero-section', 
          content: { 
            title: '{{COMPANY_NAME}}',
            subtitle: 'Board Meeting - {{CURRENT_DATE}}',
            backgroundColor: '#0f172a',
            textColor: '#ffffff',
            alignment: 'center'
          } 
        },
        { id: 'board-agenda-heading', type: 'heading', content: { text: 'Meeting Agenda', level: 2 } },
        { id: 'board-agenda', type: 'text', content: { text: '• Financial Performance Review\n• Strategic Initiative Updates\n• Operational Highlights\n• Key Decisions Required\n• Q&A and Discussion' } }
      ]
    },
    {
      title: 'Financial Update',
      blocks: [
        { id: 'board-financial-heading', type: 'heading', content: { text: 'Financial Performance Update', level: 1 } },
        { 
          id: 'board-financial-kpi', 
          type: 'kpi', 
          content: {
            title: 'Key Financial Metrics',
            metrics: [
              { label: 'Monthly Revenue', value: '{{REVENUE}}', change: '{{REVENUE_CHANGE}}', trend: 'up' },
              { label: 'Operating Expenses', value: '{{EXPENSES}}', change: '{{EXPENSE_CHANGE}}', trend: 'down' },
              { label: 'Net Profit', value: '{{NET_INCOME}}', change: '{{INCOME_CHANGE}}', trend: 'up' },
              { label: 'Cash Position', value: '{{CASH_ON_HAND}}', change: '{{CASH_CHANGE}}', trend: 'up' }
            ]
          }
        },
        { id: 'board-financial-content', type: 'text', content: { text: '{{AI_SUMMARY}}' } }
      ]
    },
    {
      title: 'Operations Update',
      blocks: [
        { id: 'board-operations-heading', type: 'heading', content: { text: 'Operational Highlights', level: 1 } },
        { id: 'board-operations-content', type: 'text', content: { text: 'Key operational updates including process improvements, team developments, technology initiatives, and operational metrics.' } }
      ]
    },
    {
      title: 'Strategic Initiatives',
      blocks: [
        { id: 'board-strategy-heading', type: 'heading', content: { text: 'Strategic Initiative Progress', level: 1 } },
        { id: 'board-strategy-content', type: 'text', content: { text: 'Updates on major strategic initiatives, project milestones, market expansion efforts, and partnership developments.' } }
      ]
    },
    {
      title: 'Key Performance Indicators',
      blocks: [
        { id: 'board-kpi-heading', type: 'heading', content: { text: 'Key Performance Indicators', level: 1 } },
        { 
          id: 'board-kpi', 
          type: 'kpi', 
          content: {
            title: 'Business Health Metrics',
            metrics: [
              { label: 'Customer Satisfaction', value: '4.8/5', trend: 'up' },
              { label: 'Employee Retention', value: '94%', trend: 'up' },
              { label: 'Market Growth', value: '+12%', trend: 'up' },
              { label: 'Product Quality Score', value: '98.2%', trend: 'up' }
            ]
          }
        }
      ]
    },
    {
      title: 'Decisions & Actions',
      blocks: [
        { id: 'board-decisions-heading', type: 'heading', content: { text: 'Key Decisions Required', level: 1 } },
        { id: 'board-decisions-content', type: 'text', content: { text: 'Critical decisions requiring board approval, resource allocation requests, strategic direction choices, and action items for follow-up.' } }
      ]
    }
  ],
  // Blank Document Template
  'blank-page': [
    {
      title: 'Blank Page',
      blocks: [
        { id: 'blank-text-1', type: 'text', content: { text: '' } }
      ]
    }
  ]
};

export const sampleTableHeaders = ['Account', 'Dec 2024', 'Nov 2024', 'Change'];
export const sampleTableRows = [
  ['Total Revenue', '$45,230', '$40,185', '+12.5%'],
  ['Cost of Goods Sold', '$18,500', '$17,200', '+7.6%'],
  ['Gross Profit', '$26,730', '$22,985', '+16.3%'],
  ['Operating Expenses', '$15,000', '$14,500', '+3.4%'],
  ['Net Income', '$11,730', '$8,485', '+38.2%']
];

export const starterTemplates = [
  {
    id: 'simple-service',
    name: 'Simple Service Business',
    description: 'Basic mapping for service-based businesses',
    categories: [
      { id: 'revenue', name: 'Revenue', description: 'All income sources', order: 1 },
      { id: 'cogs', name: 'Cost of Goods Sold', description: 'Direct costs', order: 2 },
      { id: 'marketing', name: 'Marketing & Advertising', description: 'Marketing expenses', order: 3 },
      { id: 'operations', name: 'Operations', description: 'General operating expenses', order: 4 },
      { id: 'professional', name: 'Professional Services', description: 'Legal, accounting, consulting', order: 5 },
      { id: 'other', name: 'Other Expenses', description: 'Miscellaneous expenses', order: 6 }
    ],
    mappings: {
      // Income accounts
      '1': 'revenue', // Services
      '45': 'revenue', // Landscaping Services
      '48': 'revenue', // Fountains and Garden Lighting
      '82': 'revenue', // Design income
      '85': 'revenue', // Billable Expense Income
      '54': 'revenue', // Pest Control Services
      
      // COGS accounts
      '80': 'cogs', // Cost of Goods Sold
      '92': 'cogs', // Inventory Shrinkage
      
      // Marketing accounts
      '7': 'marketing', // Advertising
      '16': 'marketing', // Promotional
      
      // Operations accounts
      '8': 'operations', // Bank Charges
      '9': 'operations', // Commissions & fees
      '10': 'operations', // Dues & Subscriptions
      '15': 'operations', // Office Expenses
      '19': 'operations', // Stationery & Printing
      '20': 'operations', // Supplies
      '24': 'operations', // Utilities
      '77': 'operations', // Telephone
      '29': 'operations', // Equipment Rental
      '55': 'operations', // Automobile
      '56': 'operations', // Fuel
      
      // Professional Services
      '12': 'professional', // Legal & Professional Fees
      '69': 'professional', // Accounting
      '70': 'professional', // Bookkeeper
      '71': 'professional', // Lawyer
      
      // Other Expenses
      '13': 'other', // Meals and Entertainment
      '17': 'other', // Rent or Lease
      '21': 'other', // Taxes & Licenses
      '22': 'other', // Travel
      '23': 'other', // Travel Meals
      '28': 'other', // Disposal Fees
      '31': 'other', // Uncategorized Expense
      '72': 'other', // Maintenance and Repair
      '78': 'other' // Purchases
    }
  },
  {
    id: 'landscaping-business',
    name: 'Landscaping Business',
    description: 'Optimized for landscaping and outdoor services',
    categories: [
      { id: 'services-revenue', name: 'Service Revenue', description: 'Landscaping and design services', order: 1 },
      { id: 'materials-revenue', name: 'Materials Revenue', description: 'Plants, materials, and supplies sold', order: 2 },
      { id: 'cogs', name: 'Cost of Goods Sold', description: 'Direct job costs', order: 3 },
      { id: 'job-expenses', name: 'Job Expenses', description: 'Labor, equipment, materials for jobs', order: 4 },
      { id: 'vehicle-equipment', name: 'Vehicle & Equipment', description: 'Transportation and equipment costs', order: 5 },
      { id: 'marketing', name: 'Marketing & Advertising', description: 'Customer acquisition', order: 6 },
      { id: 'administrative', name: 'Administrative', description: 'Office and administrative expenses', order: 7 },
      { id: 'other', name: 'Other Expenses', description: 'Miscellaneous expenses', order: 8 }
    ],
    mappings: {
      // Service Revenue
      '1': 'services-revenue', // Services
      '45': 'services-revenue', // Landscaping Services
      '82': 'services-revenue', // Design income
      '54': 'services-revenue', // Pest Control Services
      
      // Materials Revenue
      '48': 'materials-revenue', // Fountains and Garden Lighting
      '46': 'materials-revenue', // Job Materials
      '47': 'materials-revenue', // Decks and Patios
      '49': 'materials-revenue', // Plants and Soil
      '50': 'materials-revenue', // Sprinklers and Drip Systems
      
      // COGS
      '80': 'cogs', // Cost of Goods Sold
      '92': 'cogs', // Inventory Shrinkage
      
      // Job Expenses
      '58': 'job-expenses', // Job Expenses
      '59': 'job-expenses', // Cost of Labor
      '60': 'job-expenses', // Installation
      '61': 'job-expenses', // Maintenance and Repairs
      '62': 'job-expenses', // Equipment Rental (job-related)
      '63': 'job-expenses', // Job Materials
      '64': 'job-expenses', // Decks and Patios
      '65': 'job-expenses', // Fountain and Garden Lighting
      '66': 'job-expenses', // Plants and Soil
      '67': 'job-expenses', // Sprinklers and Drip Systems
      '68': 'job-expenses', // Permits
      
      // Vehicle & Equipment
      '55': 'vehicle-equipment', // Automobile
      '56': 'vehicle-equipment', // Fuel
      '37': 'vehicle-equipment', // Truck
      '38': 'vehicle-equipment', // Original Cost
      '39': 'vehicle-equipment', // Depreciation
      '29': 'vehicle-equipment', // Equipment Rental
      '72': 'vehicle-equipment', // Maintenance and Repair
      
      // Marketing
      '7': 'marketing', // Advertising
      '16': 'marketing', // Promotional
      
      // Administrative
      '8': 'administrative', // Bank Charges
      '10': 'administrative', // Dues & Subscriptions
      '12': 'administrative', // Legal & Professional Fees
      '15': 'administrative', // Office Expenses
      '19': 'administrative', // Stationery & Printing
      '20': 'administrative', // Supplies
      '24': 'administrative', // Utilities
      '77': 'administrative', // Telephone
      '11': 'administrative', // Insurance
      
      // Other
      '13': 'other', // Meals and Entertainment
      '17': 'other', // Rent or Lease
      '21': 'other', // Taxes & Licenses
      '22': 'other', // Travel
      '23': 'other', // Travel Meals
      '28': 'other', // Disposal Fees
      '31': 'other' // Uncategorized Expense
    }
  },
  {
    id: 'bookkeeper-starter',
    name: 'Bookkeeper\'s Starter Map',
    description: 'General purpose mapping for most small businesses',
    categories: [
      { id: 'income', name: 'Income', description: 'All revenue sources', order: 1 },
      { id: 'cogs', name: 'Cost of Goods Sold', description: 'Direct costs', order: 2 },
      { id: 'personnel', name: 'Personnel Costs', description: 'Payroll and benefits', order: 3 },
      { id: 'facilities', name: 'Facilities & Equipment', description: 'Rent, utilities, equipment', order: 4 },
      { id: 'marketing', name: 'Marketing & Sales', description: 'Customer acquisition', order: 5 },
      { id: 'professional', name: 'Professional Services', description: 'Legal, accounting, consulting', order: 6 },
      { id: 'other-expenses', name: 'Other Operating Expenses', description: 'Everything else', order: 7 }
    ],
    mappings: {
      // Income
      '1': 'income', // Services
      '45': 'income', // Landscaping Services
      '48': 'income', // Fountains and Garden Lighting
      '82': 'income', // Design income
      '85': 'income', // Billable Expense Income
      '54': 'income', // Pest Control Services
      
      // COGS
      '80': 'cogs', // Cost of Goods Sold
      '92': 'cogs', // Inventory Shrinkage
      
      // Personnel (if any payroll accounts exist)
      // Note: This business doesn't seem to have traditional payroll accounts
      
      // Facilities & Equipment
      '17': 'facilities', // Rent or Lease
      '24': 'facilities', // Utilities
      '77': 'facilities', // Telephone
      '11': 'facilities', // Insurance
      '29': 'facilities', // Equipment Rental
      '37': 'facilities', // Truck
      '72': 'facilities', // Maintenance and Repair
      
      // Marketing
      '7': 'marketing', // Advertising
      '16': 'marketing', // Promotional
      
      // Professional Services
      '12': 'professional', // Legal & Professional Fees
      '69': 'professional', // Accounting
      '70': 'professional', // Bookkeeper
      '71': 'professional', // Lawyer
      
      // Other Operating Expenses
      '8': 'other-expenses', // Bank Charges
      '9': 'other-expenses', // Commissions & fees
      '10': 'other-expenses', // Dues & Subscriptions
      '13': 'other-expenses', // Meals and Entertainment
      '15': 'other-expenses', // Office Expenses
      '19': 'other-expenses', // Stationery & Printing
      '20': 'other-expenses', // Supplies
      '21': 'other-expenses', // Taxes & Licenses
      '22': 'other-expenses', // Travel
      '23': 'other-expenses', // Travel Meals
      '28': 'other-expenses', // Disposal Fees
      '31': 'other-expenses', // Uncategorized Expense
      '55': 'other-expenses', // Automobile
      '56': 'other-expenses', // Fuel
      '78': 'other-expenses' // Purchases
    }
  }
];

// Available variables for insertion into documents
export const availableVariables = [
  // Financial Metrics
  { 
    name: 'REVENUE', 
    label: 'Total Revenue',
    description: 'Current period total revenue',
    category: 'Financials'
  },
  { 
    name: 'EXPENSES', 
    label: 'Total Expenses',
    description: 'Current period total expenses',
    category: 'Financials'
  },
  { 
    name: 'NET_INCOME', 
    label: 'Net Income',
    description: 'Current period net income',
    category: 'Financials'
  },
  { 
    name: 'GROSS_PROFIT',
    label: 'Gross Profit',
    description: 'Revenue minus cost of goods sold',
    category: 'Financials'
  },
  { 
    name: 'GROSS_MARGIN',
    label: 'Gross Margin %',
    description: 'Gross profit as percentage of revenue',
    category: 'Financials'
  },
  { 
    name: 'CASH_ON_HAND', 
    label: 'Cash on Hand',
    description: 'Current cash balance',
    category: 'Financials'
  },
  // Period Comparisons
  {
    name: 'REVENUE_CHANGE',
    label: 'Revenue Change %',
    description: 'Revenue change vs prior period',
    category: 'Comparisons'
  },
  {
    name: 'INCOME_CHANGE',
    label: 'Income Change %',
    description: 'Net income change vs prior period',
    category: 'Comparisons'
  },
  {
    name: 'CASH_CHANGE',
    label: 'Cash Change %',
    description: 'Cash balance change vs prior period',
    category: 'Comparisons'
  },
  {
    name: 'MARGIN_CHANGE',
    label: 'Margin Change',
    description: 'Gross margin change in percentage points',
    category: 'Comparisons'
  },
  // Company Information
  { 
    name: 'COMPANY_NAME', 
    label: 'Company Name',
    description: 'Business entity name',
    category: 'Company Info'
  },
  {
    name: 'PREPARED_BY',
    label: 'Prepared By',
    description: 'Person/firm preparing the report',
    category: 'Company Info'
  },
  // Date/Time Variables
  { 
    name: 'CURRENT_DATE', 
    label: 'Current Date',
    description: 'Today\'s date',
    category: 'Date/Time'
  },
  { 
    name: 'REPORT_DATE',
    label: 'Report Date',
    description: 'Date report was generated',
    category: 'Date/Time'
  },
  { 
    name: 'REPORT_PERIOD', 
    label: 'Report Period',
    description: 'Current reporting period',
    category: 'Date/Time'
  },
  {
    name: 'CURRENT_MONTH',
    label: 'Current Month',
    description: 'Current month name',
    category: 'Date/Time'
  },
  {
    name: 'CURRENT_YEAR',
    label: 'Current Year',
    description: 'Current year',
    category: 'Date/Time'
  },
  {
    name: 'CURRENT_QUARTER',
    label: 'Current Quarter',
    description: 'Current quarter (Q1, Q2, Q3, Q4)',
    category: 'Date/Time'
  },
  {
    name: 'MONTH_END_DATE',
    label: 'Month End Date',
    description: 'Last day of current month',
    category: 'Date/Time'
  },
  {
    name: 'NEXT_WEEK_DATE',
    label: 'Next Week Date',
    description: 'Date one week from today',
    category: 'Date/Time'
  },
  // AI Business Analysis Variables
  {
    name: 'AI_SUMMARY',
    label: 'AI Business Summary',
    description: 'AI-generated executive summary of business performance',
    category: 'AI Analysis'
  },
  {
    name: 'AI_OPPORTUNITIES',
    label: 'Growth Opportunities',
    description: 'AI-identified opportunities for business growth',
    category: 'AI Analysis'
  },
  {
    name: 'AI_RISKS',
    label: 'Business Risks',
    description: 'AI-identified risks to monitor',
    category: 'AI Analysis'
  },
  {
    name: 'AI_ANOMALIES',
    label: 'Anomalies Detected',
    description: 'AI-detected unusual changes or items requiring attention',
    category: 'AI Analysis'
  },
  {
    name: 'CASH_FLOW_OUTLOOK',
    label: 'Cash Flow Outlook',
    description: 'AI assessment of cash flow health (Red/Yellow/Green)',
    category: 'AI Analysis'
  },
  {
    name: 'OVERALL_HEALTH',
    label: 'Overall Business Health',
    description: 'AI assessment of overall business health (Red/Yellow/Green)',
    category: 'AI Analysis'
  }
];

// Real API data structure for GL accounts
export const realApiData = {
  // Current Period Financials (these will be calculated from accounts data when available)
  "revenue": 75, // fallback - will be calculated from Income accounts
  "expenses": 36, // fallback - will be calculated from Expense accounts  
  "netIncome": 39, // fallback - will be calculated
  "cogs": 0, // fallback - will be calculated from COGS accounts
  "cashOnHand": 18199.7, // fallback - will be calculated from Bank accounts (980 + 17219.7)
  
  // Prior Period for Comparisons
  "priorRevenue": 65,
  "priorExpenses": 40,
  "priorNetIncome": 25,
  "priorCashOnHand": 16000,
  "priorCogs": 0,
  
  // Company Information
  "companyName": "LedgerView Demo Co.",
  "currentDate": new Date().toLocaleDateString(),
  "reportPeriod": "Q1 2025",
  "preparedBy": "Your Accounting Firm",
  "accounts": [
    {"accountId": "33", "name": "Accounts Payable (A/P)", "type": "Accounts Payable", "val": 40608.19, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "84", "name": "Accounts Receivable (A/R)", "type": "Accounts Receivable", "val": 26304.93, "p_l": 0.0, "isDebit": true, "sub": [], "parent": null},
    {"accountId": "7", "name": "Advertising", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "89", "name": "Arizona Dept. of Revenue Payable", "type": "Other Current Liability", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "55", "name": "Automobile", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "56", "name": "Fuel", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "55"}], "parent": null},
    {"accountId": "8", "name": "Bank Charges", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "85", "name": "Billable Expense Income", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "90", "name": "Board of Equalization Payable", "type": "Other Current Liability", "val": 1824.78, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "91", "name": "Cash on hand", "type": "Bank", "val": 980.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "35", "name": "Checking", "type": "Bank", "val": 17219.7, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "9", "name": "Commissions & fees", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "80", "name": "Cost of Goods Sold", "type": "Cost of Goods Sold", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "40", "name": "Depreciation", "type": "Other Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "82", "name": "Design income", "type": "Income", "val": 75.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "86", "name": "Discounts given", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "28", "name": "Disposal Fees", "type": "Expense", "val": 36.0, "p_l": 0.0, "isDebit": true, "sub": [], "parent": null},
    {"accountId": "10", "name": "Dues & Subscriptions", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "29", "name": "Equipment Rental", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "5", "name": "Fees Billed", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "11", "name": "Insurance", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "57", "name": "Workers Compensation", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "11"}], "parent": null},
    {"accountId": "25", "name": "Interest Earned", "type": "Other Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "81", "name": "Inventory Asset", "type": "Other Current Asset", "val": 516.25, "p_l": 0.0, "isDebit": true, "sub": [], "parent": null},
    {"accountId": "92", "name": "Inventory Shrinkage", "type": "Cost of Goods Sold", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "58", "name": "Job Expenses", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "59", "name": "Cost of Labor", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "60", "name": "Installation", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "59"}, {"accountId": "61", "name": "Maintenance and Repairs", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "59"}], "parent": "58"}, {"accountId": "62", "name": "Equipment Rental", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "58"}, {"accountId": "63", "name": "Job Materials", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "64", "name": "Decks and Patios", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "63"}, {"accountId": "65", "name": "Fountain and Garden Lighting", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "63"}, {"accountId": "66", "name": "Plants and Soil", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "63"}, {"accountId": "67", "name": "Sprinklers and Drip Systems", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "63"}], "parent": "58"}, {"accountId": "68", "name": "Permits", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "58"}], "parent": null},
    {"accountId": "45", "name": "Landscaping Services", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "46", "name": "Job Materials", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "47", "name": "Decks and Patios", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "46"}, {"accountId": "48", "name": "Fountains and Garden Lighting", "type": "Income", "val": 17936.0, "p_l": 101.0, "isDebit": false, "sub": [], "parent": "46"}, {"accountId": "49", "name": "Plants and Soil", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "46"}, {"accountId": "50", "name": "Sprinklers and Drip Systems", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "46"}], "parent": "45"}, {"accountId": "51", "name": "Labor", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "52", "name": "Installation", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "51"}, {"accountId": "53", "name": "Maintenance and Repair", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "51"}], "parent": "45"}], "parent": null},
    {"accountId": "12", "name": "Legal & Professional Fees", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "69", "name": "Accounting", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "12"}, {"accountId": "70", "name": "Bookkeeper", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "12"}, {"accountId": "71", "name": "Lawyer", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "12"}], "parent": null},
    {"accountId": "43", "name": "Loan Payable", "type": "Other Current Liability", "val": 4000.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "72", "name": "Maintenance and Repair", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "73", "name": "Building Repairs", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "72"}, {"accountId": "74", "name": "Computer Repairs", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "72"}, {"accountId": "75", "name": "Equipment Repairs", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "72"}], "parent": null},
    {"accountId": "41", "name": "Mastercard", "type": "Credit Card", "val": 345.42, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "13", "name": "Meals and Entertainment", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "14", "name": "Miscellaneous", "type": "Other Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "44", "name": "Notes Payable", "type": "Long Term Liability", "val": 25000.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "15", "name": "Office Expenses", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "34", "name": "Opening Balance Equity", "type": "Equity", "val": 9337.5, "p_l": 0.0, "isDebit": true, "sub": [], "parent": null},
    {"accountId": "83", "name": "Other Income", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "26", "name": "Other Portfolio Income", "type": "Other Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "27", "name": "Penalties & Settlements", "type": "Other Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "54", "name": "Pest Control Services", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "3", "name": "Prepaid Expenses", "type": "Other Current Asset", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "16", "name": "Promotional", "type": "Expense", "val": 900.0, "p_l": 0.0, "isDebit": true, "sub": [], "parent": null},
    {"accountId": "78", "name": "Purchases", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "94", "name": "Reconciliation Discrepancies", "type": "Other Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "6", "name": "Refunds-Allowances", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "17", "name": "Rent or Lease", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "2", "name": "Retained Earnings", "type": "Equity", "val": 54090.05, "p_l": 0.0, "isDebit": true, "sub": [], "parent": null},
    {"accountId": "79", "name": "Sales of Product Income", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "36", "name": "Savings", "type": "Bank", "val": 768.0, "p_l": 0.0, "isDebit": true, "sub": [], "parent": null},
    {"accountId": "1", "name": "Services", "type": "Income", "val": 123.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "19", "name": "Stationery & Printing", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "20", "name": "Supplies", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "21", "name": "Taxes & Licenses", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "22", "name": "Travel", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "23", "name": "Travel Meals", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "37", "name": "Truck", "type": "Fixed Asset", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "39", "name": "Depreciation", "type": "Fixed Asset", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "37"}, {"accountId": "38", "name": "Original Cost", "type": "Fixed Asset", "val": 13495.0, "p_l": 0.0, "isDebit": true, "sub": [], "parent": "37"}], "parent": null},
    {"accountId": "88", "name": "Unapplied Cash Bill Payment Expense", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "87", "name": "Unapplied Cash Payment Income", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "32", "name": "Uncategorized Asset", "type": "Other Current Asset", "val": 141.0, "p_l": 0.0, "isDebit": true, "sub": [], "parent": null},
    {"accountId": "31", "name": "Uncategorized Expense", "type": "Expense", "val": 150.0, "p_l": 114.0, "isDebit": true, "sub": [], "parent": null},
    {"accountId": "30", "name": "Uncategorized Income", "type": "Income", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null},
    {"accountId": "4", "name": "Undeposited Funds", "type": "Other Current Asset", "val": 2272.36, "p_l": 0.0, "isDebit": true, "sub": [], "parent": null},
    {"accountId": "24", "name": "Utilities", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [{"accountId": "76", "name": "Gas and Electric", "type": "Expense", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": "24"}, {"accountId": "77", "name": "Telephone", "type": "Expense", "val": 101.0, "p_l": 0.0, "isDebit": true, "sub": [], "parent": "24"}], "parent": null},
    {"accountId": "42", "name": "Visa", "type": "Credit Card", "val": 0.0, "p_l": 0.0, "isDebit": false, "sub": [], "parent": null}
  ]
};

// Account Mapping System using Real GL Accounts
export const mockQBOAccounts = realApiData.accounts.map(account => ({
  id: account.accountId,
  name: account.name,
  type: account.type,
  balance: Math.abs(account.val || 0),
  isActive: true
}));

// Keep the legacy chartOfAccounts for backward compatibility with existing code that may reference it
export const chartOfAccounts = realApiData.accounts;

// Financial metrics calculation functions
export const calculateFinancialMetrics = (apiData = realApiData) => {
  // If passed the legacy accounts array format, convert to realApiData format
  if (Array.isArray(apiData)) {
    apiData = { accounts: apiData, revenue: 0, expenses: 0, netIncome: 0, cashOnHand: 0 };
  }

  const accounts = apiData.accounts || [];


  // Helper function to sum accounts by type
  const sumAccountsByType = (types) => {
    return accounts
      .filter(account => types.includes(account.type))
      .reduce((sum, account) => sum + Math.abs(account.val || 0), 0);
  };

  // Cash calculations - sum all bank accounts
  const currentCash = sumAccountsByType(['Bank']) || apiData.cashOnHand || 0;

  // Revenue calculations - sum all income accounts
  const currentRevenue = sumAccountsByType(['Income']) || apiData.revenue || 0;

  // COGS calculations
  const currentCOGS = sumAccountsByType(['Cost of Goods Sold']);

  // Gross Profit
  const currentGrossProfit = currentRevenue - currentCOGS;

  // Operating Expenses - sum all expense accounts
  const currentExpenses = sumAccountsByType(['Expense', 'Other Expense']) || apiData.expenses || 0;

  // Net Profit
  const currentNetProfit = currentGrossProfit - currentExpenses;
  
  // Use API net income if available
  const finalNetProfit = apiData.netIncome !== undefined ? apiData.netIncome : currentNetProfit;

  // Accounts Receivable and Payable
  const accountsReceivable = sumAccountsByType(['Accounts Receivable']);
  const accountsPayable = sumAccountsByType(['Accounts Payable']);

  // Marketing spend estimation (look for advertising/promotional accounts)
  const marketingAccounts = accounts.filter(acc => 
    acc.name.toLowerCase().includes('advertising') || 
    acc.name.toLowerCase().includes('promotional') ||
    acc.name.toLowerCase().includes('marketing')
  );
  const currentMarketingSpend = marketingAccounts.reduce((sum, acc) => sum + Math.abs(acc.val || 0), 0);

  // Generate previous month data (estimated as 85-95% of current for demo purposes)
  const previousMultiplier = 0.9;
  const previousCash = Math.round(currentCash * 0.88);
  const previousRevenue = Math.round(currentRevenue * previousMultiplier);
  const previousCOGS = Math.round(currentCOGS * previousMultiplier);
  const previousGrossProfit = previousRevenue - previousCOGS;
  const previousExpenses = Math.round(currentExpenses * previousMultiplier);
  const previousNetProfit = previousGrossProfit - previousExpenses;
  const previousMarketingSpend = Math.round(currentMarketingSpend * previousMultiplier);

  return {
    currentMonth: {
      cashOnHand: Math.round(currentCash),
      revenue: Math.round(currentRevenue),
      cogs: Math.round(currentCOGS),
      grossProfit: Math.round(currentGrossProfit),
      grossMargin: currentRevenue > 0 ? Math.round((currentGrossProfit / currentRevenue) * 100 * 10) / 10 : 0,
      expenses: Math.round(currentExpenses),
      netProfit: Math.round(finalNetProfit),
      marketingSpend: Math.round(currentMarketingSpend),
      netMargin: currentRevenue > 0 ? Math.round((finalNetProfit / currentRevenue) * 100 * 10) / 10 : 0,
      accountsReceivable: Math.round(accountsReceivable),
      accountsPayable: Math.round(accountsPayable)
    },
    previousMonth: {
      cashOnHand: previousCash,
      revenue: previousRevenue,
      cogs: previousCOGS,
      grossProfit: previousGrossProfit,
      grossMargin: previousRevenue > 0 ? Math.round((previousGrossProfit / previousRevenue) * 100 * 10) / 10 : 0,
      expenses: previousExpenses,
      netProfit: previousNetProfit,
      marketingSpend: previousMarketingSpend,
      netMargin: previousRevenue > 0 ? Math.round((previousNetProfit / previousRevenue) * 100 * 10) / 10 : 0,
      accountsReceivable: Math.round(accountsReceivable * 0.95),
      accountsPayable: Math.round(accountsPayable * 0.92)
    }
  };
};

// Generate historical data for 13 months based on growth patterns
export const generateHistoricalData = (baseMetrics) => {
  const months = [
    'Jun 2024', 'Jul 2024', 'Aug 2024', 'Sep 2024', 'Oct 2024', 'Nov 2024',
    'Dec 2024', 'Jan 2025', 'Feb 2025', 'Mar 2025', 'Apr 2025', 'May 2025', 'Jun 2025'
  ];
  
  const shortMonths = [
    'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov',
    'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'
  ];

  // Use current month as the last data point
  const currentMonth = baseMetrics.currentMonth;
  const previousMonth = baseMetrics.previousMonth;
  
  // Calculate growth rates
  const revenueGrowth = (currentMonth.revenue - previousMonth.revenue) / previousMonth.revenue;
  const profitGrowth = (currentMonth.netProfit - previousMonth.netProfit) / Math.abs(previousMonth.netProfit);
  const cashGrowth = (currentMonth.cashOnHand - previousMonth.cashOnHand) / previousMonth.cashOnHand;

  const data = [];
  
  for (let i = 0; i < 13; i++) {
    // Calculate values with some variation but trending upward
    const monthsFromEnd = 12 - i;
    const baseRevenue = currentMonth.revenue;
    const baseCash = currentMonth.cashOnHand;
    const baseProfit = currentMonth.netProfit;
    
    // Apply declining growth rate as we go back in time
    const revenueFactor = Math.pow(1 + revenueGrowth, -monthsFromEnd) * (0.85 + Math.random() * 0.3);
    const cashFactor = Math.pow(1 + cashGrowth, -monthsFromEnd) * (0.9 + Math.random() * 0.2);
    const profitFactor = Math.pow(1 + profitGrowth, -monthsFromEnd) * (0.8 + Math.random() * 0.4);
    
    const revenue = Math.round(baseRevenue * revenueFactor);
    const cogs = Math.round(revenue * 0.4); // Assume 40% COGS
    const grossProfit = revenue - cogs;
    const expenses = Math.round(grossProfit * 0.7); // Assume 70% of gross profit goes to expenses
    const netProfit = Math.round(baseProfit * profitFactor);
    const cashBalance = Math.round(baseCash * cashFactor);
    
    data.push({
      month: months[i],
      shortMonth: shortMonths[i],
      revenue,
      cogs,
      grossProfit,
      netProfit,
      expenses,
      cashBalance,
      newCustomers: Math.round(12 + Math.random() * 16),
      marketingSpend: Math.round(currentMonth.marketingSpend * (0.8 + Math.random() * 0.4))
    });
  }
  
  return data;
};

// Original Financial Dashboard mock data structure - now calculated from chart of accounts
export const financialDashboardData = (() => {
  const metrics = calculateFinancialMetrics();
  const historicalData = generateHistoricalData(metrics);
  
  return {
    // Hero Summary Metrics - calculated from chart of accounts
    heroMetrics: {
      currentMonth: {
        cashOnHand: metrics.currentMonth.cashOnHand,
        cashForecast90Day: Math.round(metrics.currentMonth.cashOnHand * 0.78), // Conservative 90-day forecast
        netProfitMTD: metrics.currentMonth.netProfit,
        healthScore: 78 // This could be calculated based on various financial ratios
      },
      previousMonth: {
        cashOnHand: metrics.previousMonth.cashOnHand,
        cashForecast90Day: Math.round(metrics.previousMonth.cashOnHand * 0.85),
        netProfitMTD: metrics.previousMonth.netProfit,
        healthScore: 72
      }
    },

    // Transaction metrics for current month
    transactionMetrics: {
      current: {
        totalTransactions: 487,
        arTransactions: 142,
        apTransactions: 198,
        manualReviews: 67,
        adjustments: 23,
        automatedProcessing: 397
      },
      previous: {
        totalTransactions: 431,
        arTransactions: 128,
        apTransactions: 176,
        manualReviews: 89,
        adjustments: 31,
        automatedProcessing: 339
      }
    },

    // Customer growth data (12 months)
    customerGrowthData: [
      { month: 'Jul 2024', newCustomers: 18, churned: 3, expanded: 8, contracted: 2 },
      { month: 'Aug 2024', newCustomers: 22, churned: 5, expanded: 12, contracted: 1 },
      { month: 'Sep 2024', newCustomers: 19, churned: 4, expanded: 7, contracted: 3 },
      { month: 'Oct 2024', newCustomers: 25, churned: 2, expanded: 15, contracted: 2 },
      { month: 'Nov 2024', newCustomers: 21, churned: 6, expanded: 9, contracted: 4 },
      { month: 'Dec 2024', newCustomers: 28, churned: 3, expanded: 18, contracted: 1 },
      { month: 'Jan 2025', newCustomers: 24, churned: 7, expanded: 11, contracted: 3 },
      { month: 'Feb 2025', newCustomers: 31, churned: 4, expanded: 14, contracted: 2 },
      { month: 'Mar 2025', newCustomers: 26, churned: 5, expanded: 16, contracted: 2 },
      { month: 'Apr 2025', newCustomers: 29, churned: 3, expanded: 13, contracted: 1 },
      { month: 'May 2025', newCustomers: 33, churned: 6, expanded: 19, contracted: 3 },
      { month: 'Jun 2025', newCustomers: 28, churned: 4, expanded: 12, contracted: 2 }
    ],

    // Revenue breakdown with expansion, churn, and contractions
    revenueBreakdown: {
      current: {
        newRevenue: 47200,      // From new customers
        expansionRevenue: 18300, // From existing customers growing
        churnRevenue: -12800,    // Lost from churned customers
        contractionRevenue: -4200, // Reduced from contracted customers
        baseRevenue: 6535        // Remaining baseline revenue
      },
      previous: {
        newRevenue: 39800,
        expansionRevenue: 14200,
        churnRevenue: -15600,
        contractionRevenue: -6200,
        baseRevenue: 17350
      }
    },

    // Chart goals and objectives (editable)
    chartGoals: {
      revenue: {
        type: 'percent', // 'percent', 'raw', 'flat'
        target: 15, // 15% growth
        description: 'Monthly revenue growth target'
      },
      customers: {
        type: 'raw',
        target: 35, // 35 new customers per month
        description: 'New customer acquisition target'
      },
      transactions: {
        type: 'percent',
        target: 20, // 20% increase in automated processing
        description: 'Transaction automation improvement target'
      },
      cashFlow: {
        type: 'flat',
        target: 150000, // $150k target cash balance
        description: 'Target cash balance'
      },
      churn: {
        type: 'percent',
        target: -25, // 25% reduction in churn
        description: 'Churn reduction target'
      }
    },

    // 13-month historical data for charts - generated from base metrics
    monthlyData: historicalData,

    // 90-day cash flow forecast - estimated based on current performance
    cashFlowForecast: [
      { 
        week: 'Week 1',
        date: '2025-07-14',
        expectedInflows: Math.round(metrics.currentMonth.revenue * 0.32),
        expectedOutflows: Math.round(metrics.currentMonth.expenses * 0.28),
        netChange: Math.round(metrics.currentMonth.revenue * 0.32 - metrics.currentMonth.expenses * 0.28),
        projectedBalance: metrics.currentMonth.cashOnHand + Math.round(metrics.currentMonth.revenue * 0.32 - metrics.currentMonth.expenses * 0.28)
      },
      { 
        week: 'Week 2',
        date: '2025-07-21',
        expectedInflows: Math.round(metrics.currentMonth.revenue * 0.35),
        expectedOutflows: Math.round(metrics.currentMonth.expenses * 0.32),
        netChange: Math.round(metrics.currentMonth.revenue * 0.35 - metrics.currentMonth.expenses * 0.32),
        projectedBalance: metrics.currentMonth.cashOnHand + Math.round(metrics.currentMonth.revenue * 0.67 - metrics.currentMonth.expenses * 0.60)
      },
      { 
        week: 'Week 3',
        date: '2025-07-28',
        expectedInflows: Math.round(metrics.currentMonth.revenue * 0.28),
        expectedOutflows: Math.round(metrics.currentMonth.expenses * 0.25),
        netChange: Math.round(metrics.currentMonth.revenue * 0.28 - metrics.currentMonth.expenses * 0.25),
        projectedBalance: metrics.currentMonth.cashOnHand + Math.round(metrics.currentMonth.revenue * 0.95 - metrics.currentMonth.expenses * 0.85)
      }
      // Additional weeks would follow similar pattern...
    ],

    // Current month cash flow waterfall - calculated from account categories
    cashFlowWaterfall: {
      openingCash: metrics.previousMonth.cashOnHand,
      inflows: {
        operating: metrics.currentMonth.revenue,
        financing: 0,
        investing: 2000
      },
      outflows: {
        operating: metrics.currentMonth.expenses + metrics.currentMonth.cogs,
        financing: 1500,
        investing: 500
      },
      endingBalance: metrics.currentMonth.cashOnHand
    },

    // Revenue metrics comparison table - calculated from chart of accounts
    revenueMetrics: {
      current: {
        revenue: metrics.currentMonth.revenue,
        cogs: metrics.currentMonth.cogs,
        grossProfit: metrics.currentMonth.grossProfit,
        grossMargin: metrics.currentMonth.grossMargin
      },
      previous: {
        revenue: metrics.previousMonth.revenue,
        cogs: metrics.previousMonth.cogs,
        grossProfit: metrics.previousMonth.grossProfit,
        grossMargin: metrics.previousMonth.grossMargin
      }
    },

    // Customer acquisition metrics - estimated based on marketing spend
    customerMetrics: {
      current: {
        newCustomers: 28,
        marketingSpend: metrics.currentMonth.marketingSpend,
        cac: Math.round(metrics.currentMonth.marketingSpend / 28)
      },
      previous: {
        newCustomers: 21,
        marketingSpend: metrics.previousMonth.marketingSpend,
        cac: Math.round(metrics.previousMonth.marketingSpend / 21)
      }
    },

    // Available months for navigation
    availableMonths: [
      { value: '2025-06', label: 'June 2025' },
      { value: '2025-05', label: 'May 2025' },
      { value: '2025-04', label: 'April 2025' },
      { value: '2025-03', label: 'March 2025' },
      { value: '2025-02', label: 'February 2025' },
      { value: '2025-01', label: 'January 2025' },
      { value: '2024-12', label: 'December 2024' },
      { value: '2024-11', label: 'November 2024' },
      { value: '2024-10', label: 'October 2024' },
      { value: '2024-09', label: 'September 2024' },
      { value: '2024-08', label: 'August 2024' },
      { value: '2024-07', label: 'July 2024' },
      { value: '2024-06', label: 'June 2024' }
    ]
  };
})();

// AI Enhancement Options for text improvement
export const aiEnhancementOptions = [
  {
    title: "Make More Professional",
    description: "Polish the tone and improve clarity for business contexts",
    promptTemplate: `Make this text more professional and polished while maintaining its meaning: "{text}"`
  },
  {
    title: "Make More Engaging", 
    description: "Add energy and make it more compelling to read",
    promptTemplate: `Make this text more engaging and compelling while keeping the same message: "{text}"`
  },
  {
    title: "Simplify Language",
    description: "Use simpler words and shorter sentences",
    promptTemplate: `Simplify this text to make it easier to understand: "{text}"`
  },
  {
    title: "Make More Concise",
    description: "Remove unnecessary words while keeping key information",
    promptTemplate: `Make this text more concise and to the point: "{text}"`
  },
  {
    title: "Improve Grammar",
    description: "Fix grammar, spelling, and sentence structure",
    promptTemplate: `Fix the grammar and improve the sentence structure of this text: "{text}"`
  }
];

// AI Template Prompts for document generation
export const aiTemplatePrompts = {
  'executive-summary': 'Write a professional executive summary for a {templateType}. Include key highlights, major achievements, and strategic focus areas.',
  'company-overview': 'Create a compelling company overview suitable for an investor presentation. Include mission, vision, key differentiators, and market position.',
  'financial-analysis': 'Provide a detailed financial analysis including revenue trends, profitability, cash flow insights, and key financial ratios.',
  'growth-strategy': 'Outline a comprehensive growth strategy covering market expansion, product development, partnerships, and scaling plans.',
  'outlook-recommendations': 'Present forward-looking insights including market outlook, strategic recommendations, and action items for stakeholders.',
  'funding-requirements': 'Detail funding requirements including use of funds, expected timeline, investor benefits, and growth projections.',
  'operational-update': 'Provide an operational update covering key initiatives, process improvements, team updates, and operational metrics.',
  'risk-assessment': 'Analyze key business risks including market risks, operational risks, financial risks, and mitigation strategies.'
};
